import { test } from 'ramda'
import { useEffect, useState } from 'react'
import classNames from 'classnames/bind'

import Link from 'app/common/lib/link'

import { type Fav } from './useFav'
import styles from './FavPanelView.module.scss';


const cx = classNames.bind(styles)

type Props = {
  fav: Array<Fav>
  showConditionReg?: RegExp
  darkTheme?: boolean
}

// Высота панели анимируется в CSS через grid-template-rows: 0fr -> 1fr
// (ссылки могут переноситься на несколько строк, высота заранее неизвестна),
// поэтому JS-замеры высоты и react-transition-group не нужны
const FavPanelView = ({ fav, showConditionReg, darkTheme }: Props) => {
  const [visible, setVisible] = useState(false)
  const { pathname } = window.location

  useEffect(() => {
    const showFav = !!fav.length && (!showConditionReg || test(showConditionReg, pathname))
    setVisible(showFav)
  }, [fav.length, showConditionReg, pathname])

  return (
    <div className={cx(styles.root, { [styles.visible]: visible })}>
      <div className={styles.clipper}>
        <div className={styles.container}>
          {fav.map(({ link, title, active, props = {} }) => (
            <Link
              key={link}
              to={link}
              className={cx(styles.item, {
                active: active && !darkTheme,
                activeLighten: active && darkTheme,
              })}
              {...props}
            >
              {title}
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default FavPanelView
